module.exports = __webpack_public_path__ + "media/images/application/icons/arrow-select-language-white-d0147b15ba10bc3557eb64f2bc5af038.svg";